import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {FormBuilder, ReactiveFormsModule, Validators} from "@angular/forms";
import {DynamicDialogRef} from "primeng/dynamicdialog";
import {MessageService} from "primeng/api";
import {Button} from "primeng/button";
import {Textarea} from "primeng/textarea";
import {FloatLabel} from "primeng/floatlabel";
import {CustomFormComponent, SubmitFunction} from "../custom-form/custom-form.component";
import {FeedbackService} from "../../services/feedback.service";
import {tap} from "rxjs";

@Component({
  selector: 'homey-feedback-dialog',
  imports: [
    ReactiveFormsModule,
    Button,
    Textarea,
    FloatLabel,
    CustomFormComponent,
  ],
  templateUrl: './feedback-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedbackDialogComponent {
  private readonly ref = inject(DynamicDialogRef);
  private readonly feedbackService = inject(FeedbackService);
  private readonly messageService = inject(MessageService);
  private readonly fb = inject(FormBuilder);

  protected readonly form = this.fb.group({
    message: this.fb.nonNullable.control('', [Validators.required])
  });

  protected onClose(): void {
    this.ref.close();
  }

  protected readonly submit: SubmitFunction<{message: string}> = (formData) => {
    return this.feedbackService.submitFeedback({message: formData.message}).pipe(
      tap(() => {
        this.messageService.add({
          severity: 'success',
          summary: 'Feedback sent',
          detail: 'Thank you! We really appreciate your input.'
        });
        this.ref.close();
      })
    );
  };
}
